import React, { Component } from 'react';
import withFeatureFlags from 'hocs/withFeatureFlags';

/**
 * Create a branching point to select the correct component. This helps
 * transitioning from Bootstrap components to our components.
 *
 * Setting `inHouse` to `true` selects our components for rendering.
 *
 * @param {String} name Component display name.
 * @param {Component} BsComponent Bootstrap component we are using now.
 * @param {Component} InHouseComponent Our component to be used eventually.
 */
export default function makeBranch(name, BsComponent, InHouseComponent) {
  const result = class extends Component {
    render() {
      const { inHouse, ...rest } = this.props;
      const ComponentToUse = inHouse ? InHouseComponent : BsComponent;

      return <ComponentToUse {...rest} />;
    }
  };

  result.displayName = name;

  return withFeatureFlags(flags => ({
    inHouse: flags.useReplacementDropdown,
  }))(result);
}
